module.exports = __webpack_public_path__ + "img/14-Hyphen-min.e6aff094.png";